import { parseImportedDocument } from "./document-parser";

import type { ImportIssue, WebsiteImportResult } from "./import-types";

export type CapturedUrlImage = {
  src: string;
  alt?: string;
  width?: number;
  height?: number;
};

export type CapturedUrlPage = {
  sourcePath: string;
  sourceUrl: string;
  sourceDocument: string;
  images?: CapturedUrlImage[];
};

export type CapturedUrlSite = {
  sourceUrl: string;
  pages: CapturedUrlPage[];
  issues?: Array<{
    type?: string;
    severity?: "warning" | "error";
    sourceUrl?: string;
    message?: string;
  }>;
};

export function importCapturedUrlSite(
  capture: CapturedUrlSite,
): WebsiteImportResult {
  const pages = capture.pages
    .filter((page) => Boolean(page.sourcePath) && Boolean(page.sourceDocument))
    .map((page) =>
      parseImportedDocument({
        sourcePath: page.sourcePath,
        sourceDocument: page.sourceDocument,
      }),
    );

  const issues: ImportIssue[] = (capture.issues ?? []).map((issue) => ({
    type: "parse-error",
    severity: issue.severity === "error" ? "error" : "warning",
    pagePath: issue.sourceUrl,
    value: issue.type ?? "url-capture",
    message:
      issue.message ??
      "Panderr encountered an issue while capturing this page.",
  }));

  return {
    pages,
    assets: [],
    issues,
  };
}
